import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/CommonUi/TopBar";
import { Layout } from "antd";
import "./style.css";
import { controller } from "../../controller";
import ScrapeJobsSocketManager from "../../hooks/useScrapeJobsSocket";
import GlobalScrapeJob2FAModal from "../../components/ScrapeJobs/GlobalScrapeJob2FAModal";
import ScrapeJobToastNotifier from "../../components/ScrapeJobs/ScrapeJobToastNotifier";
import GuidedOnboardingLayer from "../../components/GuidedOnboarding/GuidedOnboardingLayer";
import FtcAssistant from "../../components/FtcAssistant/FtcAssistant";
import { bootRuntimeFlags } from "../../utils/debugLog";
import TrialBanner from "../../components/Subscription/TrialBanner";

// suppressTour: don't mount the guided tour. The feature locks render this
// layout on /treatment-plans, where the tour would otherwise auto-start and
// create a demo patient for a page the office can't use.
const DashboardLayout = ({ children, breadCrumb, logo, footerLogo, suppressTour }) => {
  // A subscription started from the trial modal finishes here: Helcim's card
  // form round-trips the whole page, so the attach completes wherever the
  // user lands rather than in the modal that started it.
  // The Helcim card-return handler now lives at the app root (App.js) so a
  // return that lands outside the dashboard still completes the attach.
  const [footerLogoData, setFooterLogoData] = useState("");

  // Boot the FE → BE debug logger once. When the server reports
  // `debug: false`, the helper short-circuits all subsequent calls.
  useEffect(() => {
    bootRuntimeFlags();
  }, []);

  const getLogo = async () => {
    const response = await controller.getLogo();
    setFooterLogoData(response.data.dark);
  };

  useEffect(() => {
    if (footerLogo) {
      getLogo();
    }
  }, [footerLogo]);

  return (
    <div className="mainPart">
      <Layout className="mh100v">
        <Sidebar />
        <Layout>
          <TopBar clinicLogo={logo ? logo : ""} />
          <ScrapeJobsSocketManager />
          <GlobalScrapeJob2FAModal />
          <ScrapeJobToastNotifier />
          {suppressTour ? null : <GuidedOnboardingLayer />}
          {/* Carrier help. Renders nothing unless the signed-in user is a super
              admin or FTC personnel — and the endpoint refuses everyone else
              regardless, so the hiding is presentation, not the gate. */}
          <FtcAssistant />
          {/* Free-trial counter. Renders nothing unless this office is trialing. */}
          <TrialBanner />
          {/* {breadCrumb ? (
            <div className="page-breadcrumb">
              <span className="breadcrumb-part">{breadCrumb}</span>
            </div>
          ) : (
            ""
          )} */}
          {children}
          {footerLogoData ? (
            <>
              <div className="text-muted poweredby">
                &copy; powered by{" "}
                <img
                  alt="img"
                  className="large-logo smilinLogoPowerdBy w52"
                  src={footerLogoData}
                />
              </div>
              <div className="layout_flex_end"></div>
            </>
          ) : (
            ""
          )}
        </Layout>
      </Layout>
    </div>

  );
};

export default DashboardLayout;
